export { default } from './BottomNav';



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNav/index.js